import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_STATUS_INITIALIZED,
  STORE_USER_DOCUMENTS_REQUIRED_FETCH,
  STORE_USER_DOCUMENTS,
} from 'constants/store'
import { ErrorStore, RequiredDocumentsResponse } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type RequiredDocumentsState = {
  finished?: boolean
} & RequiredDocumentsResponse

type State = GenericState<RequiredDocumentsState>

export const initialState: State = {
  data: {
    finished: false,
    required_documents: [],
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchRequiredDocuments = createAsyncThunk<
  RequiredDocumentsState,
  Promise<RequiredDocumentsResponse>,
  Payload
>(
  STORE_USER_DOCUMENTS_REQUIRED_FETCH,
  async (promise: Promise<RequiredDocumentsState>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  RequiredDocumentsState,
  RequiredDocumentsResponse,
  Payload
>(fetchRequiredDocuments, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_USER_DOCUMENTS,
  initialState,
  reducers: {
    finishUpload: (state) => {
      return {
        ...state,
        data: {
          ...state.data,
          finished: true,
        },
      }
    },
  },
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear, success, finishUpload } = actions

export { clear, success, finishUpload }

export default reducer
